import { reduce } from 'lodash-es';

// Pivots a `market_share` dataset from { appRefNo: { metric: series } } into { metric: { appRefNo: series } }.
export const pivotMarketShare = (marketShare) =>
  reduce(
    marketShare,
    (result, seriesByMetric, appRefNo) => ({
      ...result,
      ...reduce(
        seriesByMetric,
        (acc, series, metric) => ({
          ...acc,
          [metric]: {
            ...result[metric],
            [appRefNo]: series,
          },
        }),
        {}
      ),
    }),
    {}
  );
